import React from 'react';
import { Link } from '@gumtree/ui-library';

import './pets-advice-panel.scss';
import paagImage from './paag-logo.jpg';
import { PetsAdvisory, PetsAdvisoryContent, PetsAdvisoryText } from './pets-advice-panel.style';

const PetsAdvicePanel: React.FC<{ isMobileCardsLayout?: boolean }> = ({ isMobileCardsLayout }) => (
    <PetsAdvisory isMobileCardsLayout={isMobileCardsLayout} className="pets-advisory">
        <PetsAdvisoryContent>
            <img className="pets-advisory-image" src={paagImage} alt="pets advice logo" />
            <PetsAdvisoryText data-q="pets-advice-text">
                PAAG promotes responsible pet advertising to help protect animal welfare. That's why
                Gumtree works to ensure all of our adverts meet PAAG's advertising standards.
                <Link
                    href="https://paag.org.uk/advertising-standards/"
                    openInNewTab
                    text=" Find more information on buying your pet here."
                />
            </PetsAdvisoryText>
        </PetsAdvisoryContent>
    </PetsAdvisory>
);

PetsAdvicePanel.defaultProps = {
    isMobileCardsLayout: false,
};

export default PetsAdvicePanel;
